
























import { Component, Vue } from 'vue-property-decorator'
import PhotoHeader from '@/components/organization/PhotoHeader.vue'
import Main from '@/components/organization/Main.vue'
import Paragraph from '@/components/organization/Paragraph.vue'
import HorizontalList from '@/components/organization/HorizontalList.vue'
import Speakers from '@/components/organization/Speakers.vue'
import Columns from '@/components/organization/Columns.vue'
import Organization from '@/components/organization/Names.vue'
//import Supporters from '@/components/organization/Supporters.vue'
//import { speakers_list } from '@/storage/programacao/speakers'

@Component({
  components: {
    PhotoHeader,
    Main,
    HorizontalList,
    Paragraph,
    Speakers,
    Columns,
    Organization
    //Supporters
  }
})
export default class Escola extends Vue {
  private speakers: any = null
  private photos: any

  constructor() {
    super()

    this.photos = [
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0001.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0002.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0003.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0004.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0005.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0006.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0007.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0008.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0009.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0010.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0011.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0012.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0013.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0014.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0015.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0016.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0017.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0018.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0019.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0020.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0021.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0022.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0023.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0024.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0025.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0026.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0027.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0028.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0029.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0030.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0031.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0032.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0033.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0034.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0035.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0036.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0037.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0038.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0039.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0040.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0041.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0042.jpg',
      '/assets/img/jcpoli3/FOTOS_JCPOLI3_page-0043.jpg'
      ];
  }
}
